<button
  mat-stroked-button
  [matMenuTriggerFor]="filterMenu"
  type="button"
  class="admin-stroked-button"
>
  <mat-icon>
    tune
  </mat-icon>

  <span class="bold uppercase admin-stroked-button__left-margin">
    {{ 'TRANS__FILTER__FILTRATE' | translate }}
  </span>
</button>
<mat-menu
  #filterMenu="matMenu"
  xPosition="before"
  class="removePaddingInMatMenu"
>
  @for (filterGroup of conceptsContainer.filterGroups; track $index) {
    <div>
      @if (filterGroup?.filters) {
        <ng-container>
          @if (filterGroup.filters.length || !!filterGroup.filters[0].checked_value) {
            <div mat-menu-item  [matMenuTriggerFor]="secondFilterMenu">
              <span>
                {{ filterGroup.title | translate }}
              </span>
            </div>
          }

          <mat-menu #secondFilterMenu="matMenu" class="removePaddingInMatMenu">
            @for (filter of filterGroup.filters; track $index) {
              <ng-container>
                @if (filter.value !== undefined) {
                  <button
                    [ngClass]="{'active': filter.checked}"
                    mat-menu-item
                  >
                    <mat-checkbox
                      [labelPosition]="'after'"
                      [(ngModel)]="filter.checked"
                      (ngModelChange)="filterChanged(filterGroup, filter)"
                      [name]="filter.name"
                    >
                      <span [translate]="filter.title">
                        {{ filter.title | translate }}
                      </span>
                      @if (filter.count) {
                        <span>
                           ({{filter.count}})
                        </span>
                      }
                    </mat-checkbox>
                  </button>
                }
              </ng-container>
            }
          </mat-menu>
        </ng-container>
      }
    </div>
  }
</mat-menu>
